module.exports = __webpack_public_path__ + "static/img/helpWithThisStep.cc209f12.png";